import React from "react";
import { Search, Library, Download, ShieldAlert } from "lucide-react";

const TABS = [
  { key: "search", label: "Search", icon: Search, variant: "blue" },
  { key: "library", label: "Library", icon: Library, variant: "lemon" },
  { key: "downloads", label: "Downloads", icon: Download, variant: "green" },
  { key: "quarantine", label: "Quarantine", icon: ShieldAlert, variant: "red" },
];

export default function RetroTabs({ active, onChange, quarantineCount = 0, downloadsCount = 3 }) {
  return (
    <div
      data-testid="retro-tabs"
      className="flex items-end border-b-2 border-[#808080] pt-1 px-1"
      style={{ background: "linear-gradient(to bottom, #D4D0BF 0%, #ECE9D8 100%)" }}
    >
      {TABS.map((t) => {
        const Icon = t.icon;
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            data-testid={`tab-${t.key}`}
            onClick={() => onChange(t.key)}
            className={`folder-tab ${isActive ? "active" : ""}`}
          >
            <Icon size={12} />
            {t.label}
            {t.key === "quarantine" && (
              <span
                className={`ml-1 px-1 text-white text-[9px] rounded-sm font-bold ${quarantineCount > 0 ? "bg-[#E81123] blink" : "bg-[#1F8020]"}`}
                style={{ textShadow: "none" }}
              >
                {quarantineCount}
              </span>
            )}
            {t.key === "downloads" && (
              <span
                className="ml-1 px-1 bg-[#E81123] text-white text-[9px] rounded-sm font-bold blink"
                style={{ textShadow: "none" }}
              >
                {downloadsCount}
              </span>
            )}
          </button>
        );
      })}
      <div className="flex-1 border-b-0" />
    </div>
  );
}
